import React, { useEffect, useRef, useState } from "react";

import {
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import SendIcon from "@mui/icons-material/Send";
import Tooltip from "@mui/material/Tooltip";

function Mailer({
  userEmail = "",
  getChange,
  deleteClient,
  emailFromClient,
  sendInvitation,
  updateClientExpire,
}) {

  const form = useRef();
  const [email,setEmail] = useState("");
  const [errorMessage,setErrorMessage] = useState("");
  const [copiedLink, setCopiedLink] = React.useState(0);
  const [currentLinkCopied, setCurrentLinkCopied] = React.useState("");
  
  const copyToClipBoard = async (url, id,index) => {
    try {
      
      await navigator.clipboard.writeText(url);
      setCopiedLink(id);
      setCurrentLinkCopied(index);
    } catch (err) {
      setCopiedLink(0);
    }
  };

  function sendEmail(e) {
    let client = emailFromClient.find(client => client.email == email);
    e.preventDefault();
    
    if(client){
      setErrorMessage("Board with this client has already been shared.")
    }
    else{
      sendInvitation();
    }
  }

  const handleExpireChange = (e, email) => {
    updateClientExpire(e.target.value, email);
  };

  return (
    <>
      <div>
        <div className="md-1:-ml-1">
          <form ref={form} onSubmit={sendEmail}>
            {/* <Box width="100%" /> */}
            <div className="grid grid-cols-12 col-span-12 relative">
              {/* Message */}
              <div className={`col-span-10`}>
                <TextField
                  fullWidth
                  size="small"
                  type="email"
                  required
                  name="to"
                  variant="outlined"
                  value={userEmail}
                  style={{ width: "100%", color: "#4285f4" }}
                  placeholder="Add people to collaborate"
                  onChange={(e) => {setEmail(e.target.value); getChange(e.target.value); errorMessage && setErrorMessage("")}}
                />
              </div>

              {/* Button */}
              <div className="col-span-2 flex space-x-2 justify-end">
                <Button
                  className="bg-blue-1"
                  style={{ backgroundColor: "#4285f4", color: "white" }}
                  type="submit"
                  size="large"
                >
                  <SendIcon />
                </Button>
              </div>

              {/* Show error message */}
              <div className="top-11 absolute text-red-1 text-xs ">
                  {errorMessage && errorMessage}
              </div>
            </div>
          </form>
          <div className="sticky top-0 overflow-y-scroll scrollbar mt-6" style={{overflowY: "auto", maxHeight: "300px"}}>
            {emailFromClient.length > 0 ? (
              emailFromClient.map((client, index) => {
                return (
                  <div
                    key={index}
                    className="grid grid-cols-12 gap-x-5 float-root hover:bg-grey-2 rounded-bl-full rounded-tl-full h-10 text-center w-full"
                  >
                    <h5 className="text-left mt-2 text-xs mx-2 col-span-4">
                      {client.email}
                    </h5>

                    <div className="float-right mt-2 col-span-8 grid grid-cols-12 gap-3 ml-5">
                      {/* Remaining days */}
                      <div className="mr-2 text-xs col-span-5">
                        {client.remainingDays} days remaining
                      </div>

                      <select
                        className="text-xs h-6 leading-tight outline-none border hover:bg-grey-1 col-span-3 -mt-0.5"
                        defaultValue={client.expireDate}
                        onChange={(e) => handleExpireChange(e, client.email)}
                      >
                        <option value="10" className="bg-white-1">
                          10 Day
                        </option>
                        <option value="30" className="bg-white-1">
                          30 Days
                        </option>
                        <option value="60" className="bg-white-1">
                          60 Days
                        </option>
                        <option value="90" className="bg-white-1">
                          90 Days
                        </option>
                      </select>

                      {/* Remove client */}
                      <button
                        className="capitalize text-xs col-span-2 outline-none -mt-3"
                        variant="text"
                        style={{ color: "#0B5FFF" }}
                        onClick={() => {
                          deleteClient(client.email);
                        }}
                      >
                        Remove
                      </button>
                     
                      {/* Copy link */}
                      <Tooltip
                      className="flex"
                        title= {(copiedLink === 1 && currentLinkCopied == index) ? "Copied" : "Copy Link".toLocaleLowerCase()}
                      >
                        <svg disabled={!client.link}
                         
                          onClick={() => {
                            copyToClipBoard(client.masked_url ? client.masked_url : client.link, 1,index);
                            setTimeout(() => {
                              setCopiedLink(0);
                            }, 1000);
                          }} className="col-span-2 ml-2 -mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13 14h-2a8.999 8.999 0 0 0-7.968 4.81A10.136 10.136 0 0 1 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11 13 19.5V14zm-2-2h4v3.308L20.321 11 15 6.692V10h-2a7.982 7.982 0 0 0-6.057 2.773A10.988 10.988 0 0 1 11 12z" fill="rgba(11,95,255,1)"/></svg>                  
                        </Tooltip>
                     
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="flaot-root hover:bg-grey-2 my-2 rounded-bl-full rounded-tl-full h-10 text-center min-w-mailer_width">
                <h5 className="float-left my-2 mx-2">
                  You haven't shared board with anyone
                </h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Mailer;
